import {GeneralSettings} from "../GeneralSettings/GeneralSettings";
import {RoutingTabs} from "../../../Utils/RoutingTabs/RoutingTabs";
import {Reminders} from "../Reminders/Reminders";
import {AdminUsers} from "../AdminUsers/AdminUsers";
import {FeatureFlags} from "../../../Utils/Constants";
import {useContext} from "react";
import {I18nReactContext} from "../../../contexts/I18nContext";
import {Setup} from "../Setup/Setup";
import DeletedUserTable from "../DeletedUsers/DeletedUsersTable/DeletedUserTable";
import {OrganizationUnits} from "../OrganizationUnits/OrganizationUnits";

export const SettingsTabs = () => {
    let {i18n} = useContext(I18nReactContext)
    const tabs = [
        {label: i18n.translate('settingsPage.generalSettings.title'), subPath: 'general', element: <GeneralSettings/>},
        {label: i18n.translate('settingsPage.reminders.title'), subPath: 'reminders', element: <Reminders/>},
        {
            label: i18n.translate('settingsPage.admins.title'),
            subPath: 'admins',
            element: <AdminUsers/>,
            requiredFeatureFlags: [FeatureFlags.ORG_ADMIN_MGMT]
        },
        {
            label: i18n.translate('settingsPage.setup.title'),
            subPath: 'setup',
            element: <Setup/>
        },
        {
            label: i18n.translate('settingsPage.deletedUsers.title'),
            subPath: 'deletedUsers',
            element: <DeletedUserTable/>
        },
        {
            label: i18n.translate('settingsPage.organizationalUnits.title'),
            subPath: 'organizationalUnits',
            element: <OrganizationUnits/>,
            requiredFeatureFlags: [FeatureFlags.SUB_ADMIN_CAN_CREATE_ORG],
            showForCompanyAdminRegardlessOfFeatureFlags: true
        },
        // { label: i18n.translate('settingsPage.users.title'), subPath: 'users', element: <Box>Users</Box> },

    ]
    return <RoutingTabs tabs={tabs} baseRoute={'settings'}/>

}